import { useState } from 'react'
import { authAPI } from '../../services/api'
import { useAuthStore } from '../../contexts/authStore'

import { logger } from '@/utils/logger'

export default function ChangePassword() {
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)

  const { userType } = useAuthStore()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setSuccess(false)

    if (newPassword !== confirmPassword) {
      setError('Die neuen Passwörter stimmen nicht überein.')
      return
    }

    if (newPassword.length < 8) {
      setError('Das neue Passwort muss mindestens 8 Zeichen lang sein.')
      return
    }

    setLoading(true)

    try {
      if (userType === 'admin') {
        await authAPI.changePasswordAdmin(oldPassword, newPassword)
      } else {
        await authAPI.changePasswordCustomer(oldPassword, newPassword)
      }

      setSuccess(true)
      setOldPassword('')
      setNewPassword('')
      setConfirmPassword('')
    } catch (err) {
      if (err.response?.status === 400) {
        setError('Falsches altes Passwort.')
      } else {
        setError('Fehler beim Ändern des Passworts. Bitte versuchen Sie es später erneut.')
      }
      logger.error('Password change error:', err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="wc-card wc-elev-sm" style={{ maxWidth: 420, gap: 18 }}>
      <h3 className="wc-card-title" style={{ margin: 0 }}>Passwort ändern</h3>

      {error && <div className="wc-alert wc-alert-error">{error}</div>}
      {success && <div className="wc-alert wc-alert-success">Passwort erfolgreich geändert!</div>}

      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div className="wc-field">
          <label htmlFor="oldPassword">Altes Passwort</label>
          <input
            type="password"
            id="oldPassword"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            className="wc-input"
            required
            autoComplete="current-password"
          />
        </div>

        <div className="wc-field">
          <label htmlFor="newPassword">Neues Passwort</label>
          <input
            type="password"
            id="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="wc-input"
            required
            autoComplete="new-password"
            minLength={8}
          />
        </div>

        <div className="wc-field">
          <label htmlFor="confirmPassword">Neues Passwort bestätigen</label>
          <input
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="wc-input"
            required
            autoComplete="new-password"
            minLength={8}
          />
        </div>

        <button type="submit" disabled={loading} className="wc-btn wc-btn-primary wc-btn-block">
          {loading ? 'Speichern...' : 'Passwort ändern'}
        </button>
      </form>
    </div>
  )
}
